import {Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { CameraModel } from '../camera.model';
import { ApiService } from 'src/app/api.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CODE_WORKFLOW_COMPONENT } from 'src/app/app.models';
import { ResponseWorkflowService } from 'src/app/core-api/services/responses/response-workflow.service';

@Component({
    selector: 'abw-camera-result',
    templateUrl: './camera-result.component.html',
    styleUrls: ['./camera-result.component.scss']
})
export class CameraResultComponent implements OnInit, OnChanges {
	@Input() model: CameraModel;
    @Input() value: any;
    loading = false;
    photoContent: string = null;
    errorMessage: any = null;

    constructor(
        private _apiService: ApiService,
        private _responseWorkflowService: ResponseWorkflowService,
        private _cdf: ChangeDetectorRef
    ) {
    }

    ngOnInit() {

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes.value && !!changes.value.currentValue && this.photoContent == null) {
            this.doGetFileContent(this.value);
        }
    }

    private doGetFileContent(_filename: string) {
        this.loading = true; 
        this._responseWorkflowService.doReadResponseWorkflowFile(CODE_WORKFLOW_COMPONENT.CAMERA, _filename).then(_fileContent => {
            this.photoContent = "data:image/png;base64," + _fileContent;
            this.loading = false;
            this._cdf.detectChanges();
        }, (err) => {
            this.errorMessage = err;
            this.loading = false;
        });
    }
}